//Obtiene los datos guardados de las planeaciones bases activas por fecha 
export const backgroundColorRGB = [
    'rgb(8, 110, 34)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgb(137, 161, 161)',
    'rgba(153, 102, 255, 1)', 'rgb(255, 124, 64)', 'rgba(7, 49, 26, 1)',
    "rgb(255, 0, 0)", "rgb(0, 255, 0)", "rgb(0, 0, 255)", "rgb(255, 255, 0)", "rgb(255, 0, 255)",
    "rgb(0, 255, 255)", "rgb(128, 0, 0)", "rgb(0, 128, 0)", "rgb(0, 0, 128)", "rgb(128, 128, 0)",
    "rgb(128, 0, 128)", "rgb(0, 128, 128)", "rgb(192, 192, 192)", "rgb(128, 128, 128)", "rgb(255, 165, 0)",
    "rgb(75, 0, 130)", "rgb(255, 20, 147)", "rgb(255, 69, 0)", "rgb(0, 206, 209)", "rgb(50, 205, 50)",
    "rgb(218, 165, 32)", "rgb(244, 164, 96)", "rgb(205, 92, 92)", "rgb(32, 178, 170)", "rgb(186, 85, 211)",
    "rgb(0, 191, 255)", "rgb(127, 255, 0)", "rgb(255, 105, 180)", "rgb(70, 130, 180)", "rgb(100, 149, 237)",
    "rgb(169, 169, 169)", "rgb(220, 20, 60)", "rgb(72, 61, 139)", "rgb(255, 99, 71)", "rgb(123, 104, 238)",
    "rgb(240, 128, 128)", "rgb(255, 140, 0)", "rgb(50, 205, 50)", "rgb(135, 206, 250)", "rgb(147, 112, 219)",
    "rgb(60, 179, 113)", "rgb(255, 182, 193)", "rgb(255, 160, 122)", "rgb(127, 255, 212)", "rgb(188, 143, 143)",
    "rgb(255, 218, 185)", "rgb(240, 230, 140)", "rgb(219, 112, 147)", "rgb(75, 0, 130)", "rgb(255, 127, 80)",

];

export const borderColorRGB = [
    'rgb(8, 110, 34)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgb(137, 161, 161)',
    'rgba(153, 102, 255, 1)', 'rgb(255, 124, 64)', 'rgba(7, 49, 26, 1)',
    "rgb(210, 105, 30)", "rgb(95, 158, 160)", "rgb(205, 133, 63)", "rgb(216, 191, 216)", "rgb(173, 216, 230)",
    "rgb(60, 179, 113)", "rgb(250, 250, 210)", "rgb(255, 250, 240)", "rgb(255, 228, 225)", "rgb(238, 232, 170)",
    "rgb(199, 21, 133)", "rgb(106, 90, 205)", "rgb(205, 92, 92)", "rgb(255, 99, 71)", "rgb(138, 43, 226)",
    "rgb(255, 69, 0)", "rgb(0, 250, 154)", "rgb(255, 215, 0)", "rgb(154, 205, 50)", "rgb(255, 228, 225)",
    "rgb(139, 69, 19)", "rgb(0, 255, 127)", "rgb(95, 158, 160)", "rgb(72, 209, 204)", "rgb(255, 239, 213)",
    "rgb(244, 164, 96)", "rgb(85, 107, 47)", "rgb(124, 252, 0)", "rgb(100, 149, 237)", "rgb(0, 255, 255)",
    "rgb(255, 99, 71)", "rgb(123, 104, 238)", "rgb(60, 179, 113)", "rgb(250, 128, 114)", "rgb(255, 160, 122)",
    "rgb(220, 20, 60)", "rgb(186, 85, 211)", "rgb(250, 128, 114)", "rgb(143, 188, 143)", "rgb(199, 21, 133)",
    "rgb(127, 255, 0)", "rgb(64, 224, 208)", "rgb(218, 112, 214)", "rgb(255, 228, 196)", "rgb(240, 248, 255)",
    "rgb(219, 112, 147)", "rgb(255, 228, 181)", "rgb(205, 133, 63)", "rgb(210, 180, 140)", "rgb(176, 224, 230)",

];

export function generarColorRGB() {
    let r = Math.floor(Math.random() * 256); // Rojo (0-255)
    let g = Math.floor(Math.random() * 256); // Verde (0-255)
    let b = Math.floor(Math.random() * 256); // Azul (0-255)
    return `rgb(${r}, ${g}, ${b})`;
}
